export default __webpack_public_path__ + "static/media/Trash.d9180b84.svg";